window.rwd || (window.rwd = {});

;(function($package, ScreenSize, UIComponent) {
    // TODO Poprawić akordeon żeby nie było dziwnych selektorów tylko lepszy sposób na odnajdywanie
    // head i body jeśli pod carousel_item jest jeszcze jakiś element otaczający head i body

    $package.Accordion = Accordion;
    extendz(Accordion, UIComponent);
    function Accordion(node, options) {
        UIComponent.call(this, node);
        this.options = $.extend({}, Accordion.defaults, options);
        this.node = node;
        this.namespace = "." + this.id;
        this.init();
        if (this.options.onCondition()) {
            this.on();
        }
    }
    Accordion.UI_CLASS = "accordion--ui";
    Accordion.ITEM_CLASS = "accordion_item";
    Accordion.ITEM_ACTIVE_CLASS = "accordion_item_active";
    Accordion.ITEM_INACTIVE_CLASS = "";
    Accordion.defaults = {
        onCondition: function() {
            return ScreenSize.is(ScreenSize.SIZES.SMALL);
        },
        expanded: -1
    };
    Accordion.makeAccordion = function(list) {
        var $list = $(list);
        var $accordion = $list.addClass("accordion accordion_off");
        $accordion.children().addClass(Accordion.ITEM_CLASS);
        return $accordion[0];
    };
    Accordion.makeAccordionFromContent = function(searchRoot, headerSelector) {
        var $searchRoot = $(searchRoot);
        var $accordion = $("<div>").addClass("accordion accordion_off").prependTo($searchRoot);
        $searchRoot.find(headerSelector).each(function() {
            var head = $(this);
            var contentItems = head.nextUntil(headerSelector);
            $().add(head).add(contentItems).wrapAll($("<div>").addClass(Accordion.ITEM_CLASS));
            contentItems.wrapAll($("<div>").addClass("body"));
            head.wrap($("<div>").addClass("head"));
            var item = head.closest("."+Accordion.ITEM_CLASS).appendTo($accordion);
        });
        return $accordion[0];
    };

    Accordion.prototype.remove = function (withCode) {
        withCode = typeof withCode == "boolean" ? withCode : false;
        if (withCode) {
            $(this.node).remove();
        }
        $(document).off(ScreenSize.SIZE_CHANGE_EVENT_NAME + this.namespace);
    };

    Accordion.prototype.init = function() {
        if (this.initied) {
            return;
        }
        this.inited = true;
        var that = this;

        var $node = $(this.node);
        $node
            .addClass(Accordion.UI_CLASS)
            .find("> .accordion_item").each(function(index) {
            var item = $(this);
            if (index == that.options.expanded) {
                item.addClass(Accordion.ITEM_ACTIVE_CLASS);
            } else {
                item.addClass(Accordion.ITEM_INACTIVE_CLASS);
            }
            that.registerItemControlClick(index, this);
        });

        $(document).onPage(ScreenSize.SIZE_CHANGE_EVENT_NAME + this.namespace, function () {
            that.toggle();
        });
    };
    Accordion.prototype.registerItemControlClick = function(itemIndex, itemNode) {
        var that = this;
        $(itemNode).find("> .head, > DIV > .head").onPage("click", function() {
            if (!that.isOn()) {
                return;
            }
            that.onItemControlClick(itemIndex, itemNode);
        });
    };
    Accordion.prototype.onItemControlClick = function(itemIndex, itemNode) {
        this.updateView(itemIndex, itemNode);
    };
    Accordion.prototype.updateView = function(itemIndex, itemNode) {
        var that = this;
        var $itemNode = $(itemNode);
        if (!$itemNode.hasClass(Accordion.ITEM_ACTIVE_CLASS)) {
            $(this.node).find("."+Accordion.ITEM_ACTIVE_CLASS).each(function() {
                that.itemClose(this);
            });
            this.itemOpen($itemNode);
        } else {
            this.itemClose($itemNode[0]);
        }
    };
    Accordion.prototype.itemOpen = function(itemNode, animated) {
        animated = typeof animated == "boolean" ? animated : true;
        var $itemNode = $(itemNode);
        $itemNode.removeClass(Accordion.ITEM_INACTIVE_CLASS).addClass(Accordion.ITEM_ACTIVE_CLASS);
        if (this.isOn()) {
            var $body = $itemNode.find("> .body, > DIV > .body");
            if (animated) {
                $body.slideDown(function() {
                    var scrollTop = $(window).scrollTop();
                    if (rwd.FloatingElement && $itemNode.offset().top < scrollTop) {
                        rwd.FloatingElement.animateScroll($itemNode.offset().top);
                    }
                });
            } else {
                $body.show();
            }
            this.updateDescendants($body);
        }
    };

    Accordion.prototype.itemClose = function(itemNode, animated) {
        var $itemNode = $(itemNode);
        $itemNode.removeClass(Accordion.ITEM_ACTIVE_CLASS).addClass(Accordion.ITEM_INACTIVE_CLASS);
        if (this.isOn()) {
            $itemNode.find("> .body, > DIV > .body").slideUp();
        }
    };
    Accordion.prototype.isOn = function() {
        return $(this.node).hasClass("accordion_on");
    };
    Accordion.prototype.on = function() {
        var $node = $(this.node).removeClass("accordion_off").addClass("accordion_on");
        $node.find("> .accordion_item > .body, > .accordion_item > DIV > .body").hide();
        this.itemOpen($node.find("> .accordion_item" + "."+Accordion.ITEM_ACTIVE_CLASS)[0], false);
    };
    Accordion.prototype.off = function() {
        var $node = $(this.node).removeClass("accordion_on").addClass("accordion_off");
        $node.find("> .accordion_item > .body, > .accordion_item > DIV > .body").each(function() {
            $(this).show();
        });
    };
    Accordion.prototype.toggle = function() {
        if (this.options.onCondition()) {
            this.on();
        } else {
            this.off();
        }
    };
})(rwd, rwd.ScreenSize, rwd.UIComponent);
